import React, { useState } from 'react';
import { Button, Card, Container, CardBody, CardHeader, CardText, Spinner, Input, TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import MetaTags from "react-meta-tags";
import Breadcrumbs from "components/Common/Breadcrumb";
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { addInfoBankNewInformation, deleteInfoBankInformation, getInfoBank } from 'helpers/fakebackend_helper';
import SimpleBar from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';
import DocumentCreatForm from 'components/InfoBank/DocumentCreat';
import CenterModal from 'components/Common/CenterModal';
import InfoCreateFrom from 'components/InfoBank/InfoCreateFrom';
import DeleteModal from 'components/Common/DeleteModal';
import { IMAGE_BASE_URL } from 'constants/imageUrl';


export default function InfoBank() {

  const [createdDocumentModal, setCreatedDocumentModal] = useState(false);
  const [createdInformationModal, setCreatedInformationModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteDocumentId, setDeleteDocumentId] = useState(null);
  const [selectedId, setSelectedId] = useState(null);  

  const toggleDeleteModal = () => {
    setDeleteModal(!deleteModal);
  };

  const toggleCreatedDocumentModal = () => {
    setCreatedDocumentModal(!createdDocumentModal);
  };

  const toggleCreatedInformationModal = () => {
    setCreatedInformationModal(!createdInformationModal);
  };

  const closeCreatedDocumentModal = () => {
    setCreatedDocumentModal(false);
    refetch()
  };

  const closeCreatedInformationModal = () => {
    setCreatedInformationModal(false);
    refetch()
  };

  const [files, setFiles] = useState([]);

  const [activeTab, setActiveTab] = useState('1');

  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };


  const { data, isLoading, refetch } = useQuery(
    "infoBank",
    getInfoBank,
    {
      staleTime: 60000,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    }
  )

  const { mutate: deleteDocument, isLoading: deleteDocumentLoading } = useMutation((id) => deleteInfoBankInformation(id), {
    onSuccess: () => {
      refetch();
      toggleDeleteModal();
    },
  });

  const handleDeleteDocument = (id) => {
    deleteDocument(id);
  };

  const confirmDelete = () => {
    if (selectedId) {
      handleDeleteDocument(selectedId); // Call the delete function with the selected ID
      setSelectedId(null); // Reset the selected ID after deletion
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Parenting App | InfoBank</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs title="Parenting App" breadcrumbItem="Info Bank" />
          <div >
            <Nav tabs>
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === '1' })}
                  onClick={() => toggleTab('1')}
                >
                  Emergency Information
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === '2' })}
                  onClick={() => toggleTab('2')}
                >
                  Important Documents
                </NavLink>
              </NavItem>
            </Nav>
            <TabContent activeTab={activeTab}>
              <TabPane tabId="1">
                <Card className="mt-4">
                  <CardHeader className="d-flex justify-content-end">
                    <Button color="primary" style={{ backgroundColor: "#2F8C47" }} size="sm" onClick={toggleCreatedInformationModal}>
                      Add New Information
                    </Button>
                  </CardHeader>
                  <div>
                    <div className="">
                      {isLoading ? (
                        <div className="text-center">
                          <Spinner animation="border" role="status">
                            <span className="sr-only">Loading...</span>
                          </Spinner>
                        </div>
                      ) : data?.infoBank?.informations && Array.isArray(data.infoBank.informations) && data.infoBank.informations.length > 0 ? (
                        Object.entries(data.infoBank.informations.reduce((acc, information) => {
                          const { info_type } = information;
                          if (!acc[info_type]) {
                            acc[info_type] = [];
                          }
                          acc[info_type].push(information);
                          return acc;
                        }, {})).map(([infoType, informations]) => (
                          <React.Fragment key={infoType}>
                            <Card className="mb-3">
                              <CardHeader>
                                <h6 className="mb-0">{infoType}</h6>
                              </CardHeader>
                              <CardBody>
                                {informations.map((information, index) => (
                                  <>
                                    <div key={index} className="d-flex justify-content-between align-items-center mb-2">
                                      <div className="d-flex align-items-center">
                                        <div>
                                          <p className="font-weight-bold text-primary" style={{ fontWeight: 'bold', fontSize: 'medium' }}>{information.name}</p>
                                          <p className="text-muted" style={{ fontSize: 'small' }}>
                                            {information.content?.split('\r\n').map((line, index) => (
                                              <React.Fragment key={index}>
                                                {line}
                                                {index < (information.content?.split('\r\n').length || 0) - 1 && <br />}
                                              </React.Fragment>
                                            ))}
                                          </p>
                                        </div>
                                      </div>
                                      <i className="fa fa-trash" aria-hidden="true" style={{ cursor: 'pointer', color: 'grey' }} onClick={() => { setSelectedId(information.id); toggleDeleteModal() }}></i>
                                    </div>
                                  </>
                                ))}
                              </CardBody>
                            </Card>
                          </React.Fragment>
                        ))
                      ) : (
                        <div style={{ padding: '10px' }}>
                          <InfoCreateFrom />
                        </div>
                      )}
                    </div>
                    
                    <CenterModal
                      isOpen={createdInformationModal}
                      toggle={toggleCreatedInformationModal}
                    >
                      <InfoCreateFrom onClose={closeCreatedInformationModal} />
                    </CenterModal>
                  </div>
                </Card>
              </TabPane>
              <TabPane tabId="2">
                <Card className="mt-4">
                  <CardHeader className="d-flex justify-content-end">
                    <Button color="primary" style={{ backgroundColor: "#2F8C47" }} size="sm" onClick={toggleCreatedDocumentModal}>
                      Add New Document
                    </Button>
                  </CardHeader>
                  <div>
                      <div className="overflow-auto">
                        {data?.infoBank?.documents && Array.isArray(data.infoBank.documents) && data.infoBank.documents.length > 0 ? (
                          Object.entries(data.infoBank.documents.reduce((acc, information) => {
                            const { info_type } = information;
                            if (!acc[info_type]) {
                              acc[info_type] = [];
                            }
                            acc[info_type].push(information);
                            return acc;
                          }, {})).map(([infoType, informations]) => (
                            <React.Fragment key={infoType}>
                              <Card className="mb-3">
                                <CardHeader>
                                  <h5 className="mb-0">{infoType}</h5>
                                </CardHeader>
                                <CardBody>
                                  {informations.map((information, index) => (
                                    <>
                                      <div key={index} className="d-flex justify-content-between align-items-center mb-2">
                                        <div className="d-flex align-items-center">
                                          <div>
                                            <p className="font-weight-bold text-primary" style={{ fontWeight: 'bold', fontSize: 'larger' }} > {information.name}</p>
                                            <p className="text-muted" style={{ fontSize: 'smaller' }}>
                                              {Array.isArray(information?.document_files) ? information?.document_files.map((url, index) => (
                                                <a
                                                  key={index}
                                                  href={`${IMAGE_BASE_URL}/${url}`}
                                                  download
                                                  target="_blank"
                                                  rel="noopener noreferrer"
                                                >
                                                  Download {index + 1}
                                                </a>
                                              )) : null}
                                            </p>
                                          </div>
                                        </div>
                                        <i className="fa fa-trash" aria-hidden="true" style={{ cursor: 'pointer', color: 'grey' }} onClick={() => { setSelectedId(information.id); toggleDeleteModal() }}></i>
                                      </div>
                                    </>
                                  ))}
                                </CardBody>
                              </Card>
                            </React.Fragment>
                          ))
                        ) : (
                          <div style={{ padding: '10px' }}>
                            <DocumentCreatForm />
                          </div>
                        )}
                      </div>
                    <CenterModal
                      isOpen={createdDocumentModal}
                      toggle={toggleCreatedDocumentModal}
                    >
                      <DocumentCreatForm onClose={closeCreatedDocumentModal} />
                    </CenterModal>
                 
                  </div>
                </Card>
              </TabPane>
            </TabContent>
          </div>
          <DeleteModal
            show={deleteModal}
            onDeleteClick={confirmDelete}
            onCloseClick={toggleDeleteModal}
          />
        </Container>
      </div>
    </React.Fragment>
  );
}
